import { Shield } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../../lib/site-content";
import { scrollToId } from "../../lib/scroll";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative overflow-hidden bg-[#0F172A] text-white grain"
    >
      <div className="relative mx-auto max-w-7xl px-5 py-16 sm:px-8 lg:py-20">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="grid h-9 w-9 place-items-center rounded-xl bg-[#F59E0B] text-[#0F172A]">
                <Shield className="h-5 w-5" strokeWidth={2.2} />
              </span>
              <span className="font-display text-xl font-extrabold tracking-tight">
                {COMPANY.name}
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
              {COMPANY.legalName} — specialist in Belgische accijnzen. Wij
              begeleiden producenten, importeurs en logistieke partners naar een
              volledig compliant en waterdichte accijnsflow.
            </p>
            <p className="mt-6 text-xs text-slate-500">
              BTW: {COMPANY.vat}
              <br />
              {COMPANY.address}
            </p>
          </div>

          <div className="lg:col-span-3 lg:col-start-7">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
              Navigatie
            </p>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    data-testid={`footer-nav-${l.href.replace("#", "")}`}
                    onClick={() => scrollToId(l.href)}
                    className="text-sm text-slate-300 transition-colors duration-200 hover:text-[#F59E0B]"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
              Contact
            </p>
            <ul className="mt-5 space-y-3 text-sm text-slate-300">
              <li>
                <a href={`mailto:${COMPANY.email}`} className="transition-colors hover:text-[#F59E0B]">
                  {COMPANY.email}
                </a>
              </li>
              <li>
                <a href={`tel:${COMPANY.phone}`} className="transition-colors hover:text-[#F59E0B]">
                  {COMPANY.phone}
                </a>
              </li>
            </ul>
            <button
              onClick={() => scrollToId("#contact")}
              data-testid="footer-quickscan-cta"
              className="mt-6 rounded-full bg-[#F59E0B] px-5 py-2.5 text-sm font-bold text-[#0F172A] transition-transform duration-200 hover:-translate-y-0.5"
            >
              Gratis Quickscan
            </button>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs text-slate-500">
            © {new Date().getFullYear()} {COMPANY.name}. Alle rechten voorbehouden.
          </p>
          <p className="max-w-xl text-xs leading-relaxed text-slate-500">
            Disclaimer: de informatie op deze website, inclusief de Licentie
            Checker, is louter indicatief en vormt geen bindend fiscaal of
            juridisch advies.
          </p>
        </div>
      </div>
    </footer>
  );
};
